/** First and last day of a trip as 'yyyy-MM-dd' strings (or null). */
export function tripDateRange(trip) {
  if (trip.start_date) {
    return { start: trip.start_date.slice(0, 10), end: (trip.end_date || trip.start_date).slice(0, 10) };
  }
  const dates = (trip.days || []).map(d => d.date.slice(0, 10)).sort();
  if (dates.length === 0) return { start: null, end: null };
  return { start: dates[0], end: dates[dates.length - 1] };
}

/** The trip whose dates include `date` ('yyyy-MM-dd'), or null. */
export function findTripForDate(trips, date) {
  if (!date) return null;
  return trips.find(trip => {
    const { start, end } = tripDateRange(trip);
    return start && date >= start && date <= end;
  }) || null;
}
